export default "__VITE_ASSET__OtJkMMSz__"